import { Badge } from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useNotificationsStatus } from "../../context/NotificationsContext";

export function NotificationBell() {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  const { hasNew } = useNotificationsStatus();

  const goToNotifications = () => {
    if (user?.isAdmin) {
      navigate("/admin/notifications");
    } else {
      navigate("/account/notifications");
    }
  };

  return (
    <Badge dot={hasNew} offset={[-2, 2]}>
      <BellOutlined
        onClick={goToNotifications}
        style={{ fontSize: 18, color: "var(--text-strong)", cursor: "pointer" }}
      />
    </Badge>
  );
}
